/**
 * Arabic for Staff calls and Who can call whom: the directory, the call
 * window, the ring, and the administrator's rule. Proposed; pending native
 * review.
 */
const ar: Record<string, string> = {
  /* the menu and the suite */
  "Staff calls": "مكالمات الموظفين",
  "Who can call whom": "من يتصل بمن",
  "Call a colleague inside the platform, by voice or video, one to one or as a group — like a phone's video call. The call stays on top of every screen while you work: minimised to a pill, dragged aside, expanded, or popped out above every window. Each person shows whether they are online and on what; their stored numbers dial from your device; the mobile app takes the same calls. Choose your ringtone and turn on Do not disturb, with the people who still ring through; schedule meetings with reminders; decide who can join a group call — invited only, a waiting room, or open; and in the call raise a hand, chat, share your screen, and as host let people in, mute them or remove them.":
    "اتصل بزميل داخل المنصة، صوتياً أو بالفيديو، فرداً لفرد أو جماعياً — كمكالمة الفيديو في الهاتف. تبقى المكالمة فوق كل شاشة أثناء عملك: مصغّرة إلى شريط، أو مسحوبة جانباً، أو مكبّرة، أو في نافذة مستقلة فوق كل النوافذ. يظهر لكل شخص هل هو متصل الآن وعلى أي جهاز؛ وتُطلب أرقامه المحفوظة من جهازك؛ ويستقبل تطبيق الجوال المكالمات نفسها. اختر نغمة الرنين وفعّل «عدم الإزعاج» مع من يظل اتصالهم يرنّ؛ وجدول الاجتماعات مع التذكيرات؛ وحدّد من يمكنه الانضمام إلى المكالمة الجماعية — المدعوون فقط، أو غرفة انتظار، أو مفتوحة؛ وفي أثناء المكالمة ارفع يدك، واستخدم الدردشة، وشارك شاشتك، وبصفتك المضيف اسمح للأشخاص بالدخول أو اكتم صوتهم أو أخرجهم.",
  "The administrator's rule for staff calls: which access level may call which, who may use video and start group calls, which levels may break through Do not disturb with an urgent call, how many people a call holds and how long it rings, and exceptions for a person, a role or a level — each answer explained by a checker.":
    "قاعدة المسؤول لمكالمات الموظفين: أي مستوى وصول يتصل بأي مستوى، ومن يستخدم الفيديو ويبدأ المكالمات الجماعية، وأي المستويات يمكنها تجاوز «عدم الإزعاج» بمكالمة عاجلة، وكم شخصاً تتسع له المكالمة وكم ترنّ، والاستثناءات لشخص أو دور أو مستوى — وكل إجابة يشرحها المدقّق.",
  "Staff calls — {n} missed call|Staff calls — {n} missed calls":
    "مكالمات الموظفين — لا مكالمات فائتة|مكالمات الموظفين — مكالمة فائتة واحدة|مكالمات الموظفين — مكالمتان فائتتان|مكالمات الموظفين — {n} مكالمات فائتة|مكالمات الموظفين — {n} مكالمة فائتة|مكالمات الموظفين — {n} مكالمة فائتة",

  /* the directory */
  "Staff calls are not open to this sign-in. An administrator can give your role the calls permission.":
    "مكالمات الموظفين غير متاحة لهذا الحساب. يمكن للمسؤول منح دورك صلاحية المكالمات.",
  "{n} colleagues on staff calls, {o} online now.": "{n} زميلاً على مكالمات الموظفين، {o} متصلون الآن.",
  "{n} missed call in the recent list.|{n} missed calls in the recent list.":
    "لا مكالمات فائتة في القائمة الأخيرة.|مكالمة فائتة واحدة في القائمة الأخيرة.|مكالمتان فائتتان في القائمة الأخيرة.|{n} مكالمات فائتة في القائمة الأخيرة.|{n} مكالمة فائتة في القائمة الأخيرة.|{n} مكالمة فائتة في القائمة الأخيرة.",
  "Who can call whom?": "من يتصل بمن؟",
  "Call a colleague by voice or video, one to one or as a group. The call stays on top while you keep working — minimize it, drag it aside, or pop it out above every window.":
    "اتصل بزميل صوتياً أو بالفيديو، فرداً لفرد أو جماعياً. تبقى المكالمة في الأعلى وأنت تواصل العمل — صغّرها، أو اسحبها جانباً، أو افتحها في نافذة فوق كل النوافذ.",
  "Who can call whom →": "من يتصل بمن ←",
  "Sample staff": "موظفون تجريبيون",
  "These are the demonstration's people, not your colleagues. A call to one of them rings, is answered by a stand-in, and says on screen that nobody is on the line. Your own camera and microphone are real if you allow them.":
    "هؤلاء أشخاص العرض التجريبي، لا زملاؤك. المكالمة لأحدهم ترنّ ويجيب عليها بديل، وتقول الشاشة إنه لا أحد على الخط. كاميرتك وميكروفونك حقيقيان إن سمحت بهما.",
  "Try an incoming call": "جرّب مكالمة واردة",
  "Try an incoming video call": "جرّب مكالمة فيديو واردة",
  "search a name, a trade, a department, a number": "ابحث عن اسم أو تخصص أو إدارة أو رقم",
  "Search staff": "البحث عن موظف",
  "Mute the ringtone": "كتم نغمة الرنين",
  "{n} on staff calls · {o} online": "{n} على مكالمات الموظفين · {o} متصلون",
  "{n} person chosen|{n} people chosen":
    "لم يُختر أحد|اختير شخص واحد|اختير شخصان|اختير {n} أشخاص|اختير {n} شخصاً|اختير {n} شخص",
  "A call holds up to {n} people, you included.": "تتسع المكالمة لـ {n} أشخاص كحد أقصى، وأنت منهم.",
  "Your level may not start group calls.": "لا يسمح مستواك ببدء مكالمات جماعية.",
  "Group call (Voice)": "مكالمة جماعية (صوت)",
  "Group call (Video)": "مكالمة جماعية (فيديو)",
  Colleagues: "الزملاء",
  "Online first. A refused button says why; the numbers dial from your device.":
    "المتصلون أولاً. الزر المرفوض يذكر السبب؛ والأرقام تُطلب من جهازك.",
  "Nobody else is on staff calls yet.": "لا أحد غيرك على مكالمات الموظفين بعد.",
  "Recent calls": "المكالمات الأخيرة",
  "Calls you made, took or missed. Missed calls are in red.":
    "المكالمات التي أجريتها أو تلقيتها أو فاتتك. الفائتة باللون الأحمر.",
  "Phone only": "هاتف فقط",
  "People in the contact directory with no sign-in to the platform: reached by telephone, not in the app.":
    "أشخاص في دليل جهات الاتصال بلا حساب على المنصة: يُتصل بهم هاتفياً لا من التطبيق.",
  "Nobody in the contact directory is phone only.": "لا أحد في دليل جهات الاتصال للهاتف فقط.",
  "The policy does not allow this call.": "القاعدة لا تسمح بهذه المكالمة.",
  "Your level cannot use video.": "لا يسمح مستواك باستخدام الفيديو.",
  "Choose for a group call": "اختر لمكالمة جماعية",
  "Choose {name} for a group call": "اختر {name} لمكالمة جماعية",
  "Voice call {name}": "مكالمة صوتية مع {name}",
  "Video call {name}": "مكالمة فيديو مع {name}",
  "Dial from this device": "اطلب من هذا الجهاز",
  "No calls yet.": "لا مكالمات بعد.",
  "A colleague": "زميل",
  "Call back": "معاودة الاتصال",
  "Call notifications are on": "إشعارات المكالمات مفعّلة",
  "Call notifications are blocked in this browser's settings": "إشعارات المكالمات محظورة في إعدادات هذا المتصفح",
  "Allow call notifications": "السماح بإشعارات المكالمات",
  Online: "متصل",
  "Online · phone": "متصل · الجوال",
  "Not seen yet": "لم يظهر بعد",
  "Last seen {n} min ago": "آخر ظهور قبل {n} دقيقة",
  "Last seen {n} h ago": "آخر ظهور قبل {n} ساعة",
  "Last seen {n} days ago": "آخر ظهور قبل {n} يوم",
  Declined: "مرفوضة",
  "No answer": "لا رد",
  Answered: "تم الرد",
  Office: "المكتب",

  /* the window and the ring */
  "Call ended": "انتهت المكالمة",
  "Incoming call": "مكالمة واردة",
  "Incoming call — {name}": "مكالمة واردة — {name}",
  "Incoming call from {name}": "مكالمة واردة من {name}",
  "Video call": "مكالمة فيديو",
  "Voice call": "مكالمة صوتية",
  "{n} other on the call|{n} others on the call":
    "لا أحد غيره على المكالمة|وشخص آخر على المكالمة|وشخصان آخران على المكالمة|و{n} آخرون على المكالمة|و{n} آخرين على المكالمة|و{n} آخر على المكالمة",
  "Sample call — nobody is on this line": "مكالمة تجريبية — لا أحد على هذا الخط",
  "Sample stand-in": "بديل تجريبي",
  "Choose who to ring": "اختر من تتصل به",
  Decline: "رفض",
  Video: "الفيديو",
  "Keep this call on top of everything, even other applications. Chrome and Edge open it as its own always-on-top window; Safari floats the video.":
    "أبقِ هذه المكالمة فوق كل شيء، حتى التطبيقات الأخرى. يفتحها Chrome وEdge في نافذة مستقلة تبقى في الأعلى دائماً؛ ويُطفي Safari الفيديو.",
  "Keep on top of everything": "إبقاء فوق كل شيء",
  "The call is in its own window": "المكالمة في نافذة مستقلة",
  "Bring it back": "إعادتها",
  "Staff call": "مكالمة موظفين",
  "Nobody else is on the call": "لا أحد غيرك على المكالمة",
  "Restore the call window": "استعادة نافذة المكالمة",
  "Calling…": "جارٍ الاتصال…",
  "Calling {name}…": "جارٍ الاتصال بـ {name}…",
  Unmute: "إلغاء الكتم",
  "Hang up": "إنهاء المكالمة",
  "Cancel call": "إلغاء المكالمة",
  "Ringing…": "يرنّ…",
  "Restore size": "استعادة الحجم",
  Expand: "تكبير",
  "Turn camera off": "إيقاف الكاميرا",
  "Turn camera on": "تشغيل الكاميرا",
  "Switch to voice": "التحويل إلى صوت",
  "Switch to video": "التحويل إلى فيديو",
  "Add people": "إضافة أشخاص",
  Muted: "مكتوم",
  "Reconnecting…": "جارٍ إعادة الربط…",
  "Could not connect": "تعذّر الربط",
  "Search a name": "ابحث عن اسم",
  "Not allowed": "غير مسموح",
  "room for {n} more|room for {n} more":
    "لا مكان لأحد آخر|مكان لشخص واحد آخر|مكان لشخصين آخرين|مكان لـ {n} آخرين|مكان لـ {n} آخرين|مكان لـ {n} آخرين",
  "Ring {n} person|Ring {n} people":
    "لا أحد للاتصال|اتصل بشخص واحد|اتصل بشخصين|اتصل بـ {n} أشخاص|اتصل بـ {n} شخصاً|اتصل بـ {n} شخص",
  "This browser cannot reach a microphone or camera here — it needs a secure (https) page.":
    "لا يستطيع هذا المتصفح الوصول إلى الميكروفون أو الكاميرا هنا — يحتاج إلى صفحة آمنة (https).",
  "Camera refused — this call is voice only.": "رُفضت الكاميرا — هذه المكالمة صوتية فقط.",
  "Microphone and camera refused — you can listen but not be heard.":
    "رُفض الميكروفون والكاميرا — يمكنك الاستماع لكن لا يُسمع صوتك.",
  "Microphone refused — you can listen but not be heard.": "رُفض الميكروفون — يمكنك الاستماع لكن لا يُسمع صوتك.",
  "Your level cannot use video — you joined by voice.": "لا يسمح مستواك بالفيديو — انضممت بالصوت.",
  "Your level cannot use video — this call is voice only.": "لا يسمح مستواك بالفيديو — هذه المكالمة صوتية فقط.",
  "Your level cannot use video — the call was made as a voice call.":
    "لا يسمح مستواك بالفيديو — أُجريت المكالمة صوتية.",
  "Finish the call you are on first.": "أنهِ المكالمة الحالية أولاً.",

  /* the decision, as the platform words it */
  "You cannot call yourself.": "لا يمكنك الاتصال بنفسك.",
  "Your sign-in is disabled.": "حسابك معطّل.",
  "This person's sign-in is disabled.": "حساب هذا الشخص معطّل.",
  "You are not on staff calls.": "أنت لست على مكالمات الموظفين.",
  "This person is not on staff calls.": "هذا الشخص ليس على مكالمات الموظفين.",
  "Refused by an exception: {note}": "مرفوضة باستثناء: {note}",
  "Refused by an exception set by the administrator.": "مرفوضة باستثناء وضعه المسؤول.",
  "Allowed by an exception: {note}": "مسموحة باستثناء: {note}",
  "Allowed by an exception set by the administrator.": "مسموحة باستثناء وضعه المسؤول.",
  "{from} may call {to}.": "يمكن لـ {from} الاتصال بـ {to}.",
  "{from} may not call {to}.": "لا يمكن لـ {from} الاتصال بـ {to}.",
  "{from} may call everyone.": "يمكن لـ {from} الاتصال بالجميع.",
  "{from} may call nobody.": "لا يمكن لـ {from} الاتصال بأحد.",
  "{from} may call only:": "يمكن لـ {from} الاتصال فقط بـ:",

  /* who can call whom */
  "Staff calls are open: everyone may call everyone.": "مكالمات الموظفين مفتوحة: يمكن للجميع الاتصال بالجميع.",
  "{n} level pairings closed and {x} exceptions.": "{n} من أزواج المستويات مغلقة و{x} استثناءات.",
  "Who may call whom on staff calls. Open by default — an airport's internal line is open until somebody narrows it. Narrow it by level below, then name the exceptions a level cannot express.":
    "من يتصل بمن على مكالمات الموظفين. مفتوحة افتراضياً — الخط الداخلي للمطار مفتوح حتى يضيّقه أحد. ضيّقه حسب المستوى أدناه، ثم سمِّ الاستثناءات التي لا يعبّر عنها المستوى.",
  "Staff calls →": "مكالمات الموظفين ←",
  "You can read this rule but not change it: changing it needs the calls policy permission, which administrators hold.":
    "يمكنك قراءة هذه القاعدة لا تغييرها: تغييرها يحتاج صلاحية قاعدة المكالمات التي يملكها المسؤولون.",
  Levels: "المستويات",
  "Rows are the caller, columns whom they can call. A call is allowed one way at a time.":
    "الصفوف هي المتصل، والأعمدة من يمكنه الاتصال به. يُسمح بالمكالمة في اتجاه واحد في كل مرة.",
  Caller: "المتصل",
  "Can call": "يمكنه الاتصال بـ",
  "May use video": "يستخدم الفيديو",
  "May start group calls": "يبدأ مكالمات جماعية",
  "{from} may call {to}": "يمكن لـ {from} الاتصال بـ {to}",
  "{level} may use video": "يمكن لـ {level} استخدام الفيديو",
  "{level} may start group calls": "يمكن لـ {level} بدء مكالمات جماعية",
  "Voice only.": "صوت فقط.",
  "No group calls.": "لا مكالمات جماعية.",
  "Group size and ringing": "حجم المجموعة والرنين",
  "Most people on one call": "أكبر عدد على مكالمة واحدة",
  "Ring for (seconds)": "مدة الرنين (ثوانٍ)",
  "Between 2 and 8 people. Every phone and browser on a call sends its picture to every other one directly, so above 8 the calls would stutter; larger calls need a media server, which is the next step and is not installed. A ring nobody answers is recorded as missed after the ring time.":
    "بين 2 و8 أشخاص. كل هاتف ومتصفح في المكالمة يرسل صورته إلى كل الآخرين مباشرة، فإن زاد العدد على 8 تقطّعت المكالمات؛ والمكالمات الأكبر تحتاج خادم وسائط، وهو الخطوة التالية ولم يُثبَّت. الرنين الذي لا يُجاب يُسجَّل فائتاً بعد مدة الرنين.",
  "In a group, the person who invites somebody must be allowed to call them; the people already on the call need not be allowed to call each other — it is a conference.":
    "في المجموعة، يجب أن يُسمح لمن يدعو شخصاً بالاتصال به؛ ولا يلزم أن يُسمح للموجودين على المكالمة بالاتصال ببعضهم — إنها مؤتمر.",
  "Restore the open default": "استعادة الوضع المفتوح الافتراضي",
  "Changes not saved yet.": "التغييرات لم تُحفظ بعد.",
  "Saved. Calls follow the new rule from now.": "حُفظت. تتبع المكالمات القاعدة الجديدة من الآن.",
  "A relay (TURN) server is configured: calls connect across networks, a phone on mobile data included.":
    "خادم ترحيل (TURN) مضبوط: تتصل المكالمات عبر الشبكات، بما فيها هاتف على بيانات الجوال.",
  "No relay (TURN) server is configured: calls between different networks — for example a phone on mobile data — may not connect. Ask IT to set SLT_TURN_URLS and SLT_TURN_SECRET.":
    "لا يوجد خادم ترحيل (TURN) مضبوط: قد لا تتصل المكالمات بين شبكات مختلفة — مثل هاتف على بيانات الجوال. اطلب من تقنية المعلومات ضبط SLT_TURN_URLS وSLT_TURN_SECRET.",
  Exceptions: "الاستثناءات",
  "Checked before the levels. A deny beats an allow.": "تُفحص قبل المستويات. المنع يغلب السماح.",
  Anyone: "أي شخص",
  "anyone at {level}": "أي شخص في {level}",
  "role: {role}": "الدور: {role}",
  You: "أنت",
  "No exceptions: the levels decide every call.": "لا استثناءات: المستويات تقرر كل مكالمة.",
  Allow: "سماح",
  Deny: "منع",
  "from {from} to {to}": "من {from} إلى {to}",
  "why — shown to the person refused": "السبب — يُعرض لمن يُرفض",
  "Add the exception": "إضافة الاستثناء",
  "Can one person call another?": "هل يستطيع شخص الاتصال بآخر؟",
  "The answer and the rule that gives it, for the changes on screen.":
    "الإجابة والقاعدة التي تعطيها، للتغييرات المعروضة على الشاشة.",
  Calls: "يتصل بـ",
  "Ask the platform (saved rule)": "اسأل المنصة (القاعدة المحفوظة)",
  "By voice only — the caller's level has no video.": "بالصوت فقط — مستوى المتصل بلا فيديو.",
  "Saved rule:": "القاعدة المحفوظة:",
  "Allowed.": "مسموح.",
  "Refused.": "مرفوض.",

  /* v2 (2026-10-03): ringtone, Do not disturb, meetings, who can join, the lobby, in-call people/chat/settings, screen share */
  Chat: "الدردشة",
  "Meeting panel": "لوحة الاجتماع",
  "Close the panel": "أغلق اللوحة",
  "Mute all": "كتم الجميع",
  Admit: "اسمح بالدخول",
  "Hands raised": "الأيدي المرفوعة",
  "{name} (you)": "{name} (أنت)",
  "Hand raised": "يد مرفوعة",
  "Hand raised, {n} in line": "يد مرفوعة، الترتيب {n}",
  "Sharing their screen": "يشارك شاشته",
  "Microphone on": "الميكروفون يعمل",
  "Camera on": "الكاميرا تعمل",
  "Camera off": "الكاميرا متوقفة",
  "Actions for {name}": "إجراءات لـ {name}",
  "Remove co-host": "إلغاء المضيف المشارك",
  "Make co-host": "اجعله مضيفاً مشاركاً",
  "Make host": "اجعله المضيف",
  "Remove from call": "أخرجه من المكالمة",
  "Mute asks their device to mute; they can unmute themselves. Removing someone also stops them joining again.":
    "الكتم يطلب من جهازه كتم الصوت، ويمكنه إلغاء الكتم بنفسه. وإخراج شخص يمنعه أيضاً من الانضمام مجدداً.",
  "No messages yet. What is written here stays with the call.": "لا رسائل بعد. ما يُكتب هنا يبقى مع المكالمة.",
  "Write to everyone on the call": "اكتب لكل من في المكالمة",
  Message: "رسالة",
  "Only the host and co-hosts can change these.": "لا يغيّر هذه إلا المضيف والمضيفون المشاركون.",
  "A name for this call": "اسم لهذه المكالمة",
  "Who can join": "من يمكنه الانضمام",
  "Lock the call": "اقفل المكالمة",
  "Nobody new can join or ask to — only the people already invited.":
    "لا يمكن لأحد جديد الانضمام أو طلبه — المدعوون فقط.",
  "{n} waiting to join|{n} waiting to join":
    "لا أحد ينتظر الانضمام|شخص واحد ينتظر الانضمام|شخصان ينتظران الانضمام|{n} أشخاص ينتظرون الانضمام|{n} شخصاً ينتظرون الانضمام|{n} شخص ينتظرون الانضمام",
  "{n} on the call|{n} on the call":
    "لا أحد في المكالمة|شخص واحد في المكالمة|شخصان في المكالمة|{n} أشخاص في المكالمة|{n} شخصاً في المكالمة|{n} شخص في المكالمة",
  Host: "المضيف",
  "Co-host": "مضيف مشارك",
  "May break through Do not disturb": "يمكنه تجاوز «عدم الإزعاج»",
  "{level} may break through Do not disturb": "يمكن لمستوى {level} تجاوز «عدم الإزعاج»",
  "Urgent calls ring through Do not disturb.": "المكالمات العاجلة ترنّ رغم «عدم الإزعاج».",
  "Do not disturb: a person can stop calls ringing for a while. Their own list of people still rings through; an urgent call rings through only from a level ticked under “May break through Do not disturb” — none by default. Who can join a group call, and its lobby, is set by the person who starts it, inside this rule: nobody joins who may not call the host.":
    "عدم الإزعاج: يستطيع الشخص إيقاف رنين المكالمات لفترة. تظل قائمته الخاصة من الأشخاص ترنّ؛ ولا ترنّ المكالمة العاجلة إلا من مستوى مؤشَّر عليه تحت «يمكنه تجاوز عدم الإزعاج» — ولا مستوى افتراضياً. ومن يمكنه الانضمام إلى مكالمة جماعية وغرفة انتظارها يحدده من يبدؤها، ضمن هذه القاعدة: لا ينضم من لا يُسمح له بالاتصال بالمضيف.",
  "A group call": "مكالمة جماعية",
  "Waiting to join": "بانتظار الانضمام",
  "Waiting for the host to let you in…": "بانتظار أن يسمح لك المضيف بالدخول…",
  "Host: {name}": "المضيف: {name}",
  "Live now": "مباشر الآن",
  "Starting now": "يبدأ الآن",
  Join: "انضم",
  "Meeting reminder": "تذكير باجتماع",
  "Sample meeting": "اجتماع تجريبي",
  Dismiss: "تجاهل",
  "Locked: nobody new can join": "مقفلة: لا يمكن لأحد جديد الانضمام",
  "Call settings": "إعدادات المكالمة",
  "Stop sharing": "أوقف المشاركة",
  "Share screen": "شارك الشاشة",
  "Lower hand": "أنزل يدك",
  "Raise hand": "ارفع يدك",
  "End for all": "إنهاء للجميع",
  "You are sharing your screen": "أنت تشارك شاشتك",
  "{name} is sharing their screen": "{name} يشارك شاشته",
  "Waiting for the shared screen…": "بانتظار الشاشة المشارَكة…",
  "Starts in {n} min|Starts in {n} min":
    "يبدأ الآن|يبدأ خلال دقيقة|يبدأ خلال دقيقتين|يبدأ خلال {n} دقائق|يبدأ خلال {n} دقيقة|يبدأ خلال {n} دقيقة",
  "until you turn it off": "حتى توقفه بنفسك",
  "until {time}": "حتى {time}",
  "until tomorrow {time}": "حتى الغد {time}",
  "Do not disturb is on": "«عدم الإزعاج» مفعّل",
  "Do not disturb": "عدم الإزعاج",
  "Available for calls": "متاح للمكالمات",
  "Calls do not ring, {until}. Callers see a missed call.": "المكالمات لا ترنّ {until}. ويرى المتصل مكالمة فائتة.",
  "Calls ring on this device.": "المكالمات ترنّ على هذا الجهاز.",
  "Open Staff calls": "افتح مكالمات الموظفين",
  "Ringtone and who rings through…": "نغمة الرنين ومن يرنّ رغم ذلك…",
  "{n} missed|{n} missed": "لا فائتة|فائتة واحدة|فائتتان|{n} فائتة|{n} فائتة|{n} فائتة",
  "1 hour": "ساعة واحدة",
  "Until tomorrow 07:00": "حتى الغد 07:00",
  "Until I turn it off": "حتى أوقفه بنفسي",
  "You are on Do not disturb: a sample call will not ring — it is listed as missed.":
    "أنت في وضع «عدم الإزعاج»: لن ترنّ المكالمة التجريبية — ستُدرج كمكالمة فائتة.",
  "A title for the call (optional)": "عنوان للمكالمة (اختياري)",
  "Somebody chosen is on Do not disturb: they will not ring, and will see a missed call.":
    "أحد المختارين في وضع «عدم الإزعاج»: لن يرنّ هاتفه، وسيرى مكالمة فائتة.",
  "{name} is on Do not disturb": "{name} في وضع «عدم الإزعاج»",
  "Your call will not ring for them. They will see it as a missed call when Do not disturb ends, and can call you back.":
    "لن ترنّ مكالمتك عنده. سيراها مكالمة فائتة عند انتهاء «عدم الإزعاج»، ويمكنه معاودة الاتصال بك.",
  "Your level may make an urgent call, which rings through Do not disturb. Keep it for what cannot wait.":
    "يمكن لمستواك إجراء مكالمة عاجلة ترنّ رغم «عدم الإزعاج». احتفظ بها لما لا يحتمل الانتظار.",
  "Your level cannot break through Do not disturb.": "لا يمكن لمستواك تجاوز «عدم الإزعاج».",
  "Video call anyway": "اتصل بالفيديو على أي حال",
  "Call anyway": "اتصل على أي حال",
  "Urgent call": "مكالمة عاجلة",
  "Also let in directly:": "واسمح بالدخول مباشرةً لـ:",
  "nobody else": "لا أحد غيرهم",
  "Remove {name}": "أزل {name}",
  "The administrator's rule still applies: nobody comes in who may not call the host.":
    "تبقى قاعدة المسؤول سارية: لا يدخل من لا يُسمح له بالاتصال بالمضيف.",
  "Invited only": "المدعوون فقط",
  "Ask to join": "اطلب الانضمام",
  "Only the people you ring can come in.": "لا يدخل إلا من تتصل بهم.",
  "Anyone may ask; a host lets them in from the lobby.":
    "يمكن لأي شخص الطلب؛ ويسمح له المضيف بالدخول من غرفة الانتظار.",
  "Anyone on staff calls the rules allow may come straight in.":
    "يمكن لأي شخص على مكالمات الموظفين تسمح له القواعد أن يدخل مباشرةً.",
  Meetings: "الاجتماعات",
  "Group calls with a time and an agenda. Everyone invited is rung when it starts; a reminder comes 15 and 5 minutes before.":
    "مكالمات جماعية لها موعد وجدول أعمال. يُتصل بكل المدعوين عند بدئها؛ ويصل تذكير قبلها بـ 15 و5 دقائق.",
  "Meet now": "اجتمع الآن",
  "Schedule a meeting": "جدولة اجتماع",
  "Live calls you can join": "مكالمات مباشرة يمكنك الانضمام إليها",
  "Which meetings": "أي اجتماعات",
  Upcoming: "القادمة",
  Past: "السابقة",
  "No meetings coming up. Schedule one, or meet now.": "لا اجتماعات قادمة. جدول اجتماعاً، أو اجتمع الآن.",
  "Cancel “{title}”? Everyone invited will see it canceled.": "إلغاء «{title}»؟ سيرى كل المدعوين أنه أُلغي.",
  "No past meetings.": "لا اجتماعات سابقة.",
  "Not held": "لم يُعقد",
  Sample: "تجريبي",
  "Organiser: {name}": "المنظّم: {name}",
  "Cancel meeting": "ألغِ الاجتماع",
  "Quick meeting": "اجتماع سريع",
  "Edit the meeting": "عدّل الاجتماع",
  "Starts as soon as you press Start: everyone you choose is rung.": "يبدأ حين تضغط «ابدأ»: يُتصل بكل من تختارهم.",
  "e.g. Apron safety walk — briefing": "مثلاً: جولة سلامة الساحة — إحاطة",
  "{h} h {m} min": "{h} س {m} د",
  "{h} h": "{h} س",
  "What the meeting is for, in a line or two": "الغرض من الاجتماع، في سطر أو سطرين",
  "{n} chosen · a call holds up to {max} people, you included":
    "تم اختيار {n} · تتسع المكالمة حتى {max} أشخاص، وأنت منهم",
  "{n} invited|{n} invited": "لا مدعوين|مدعو واحد|مدعوان|{n} مدعوين|{n} مدعواً|{n} مدعو",
  Agenda: "جدول الأعمال",
  Duration: "المدة",
  Call: "المكالمة",
  "Voice or video": "صوت أو فيديو",
  "Give the meeting a title.": "أعطِ الاجتماع عنواناً.",
  "A title is at most 160 characters.": "العنوان 160 حرفاً على الأكثر.",
  "Invite at least one person.": "ادعُ شخصاً واحداً على الأقل.",
  "Too many people for one call.": "عدد الأشخاص أكبر مما تتسع له مكالمة واحدة.",
  "Choose a date and a time.": "اختر تاريخاً ووقتاً.",
  "That time has passed.": "هذا الوقت قد مضى.",
  "A meeting lasts between 5 minutes and 8 hours.": "يستمر الاجتماع بين 5 دقائق و8 ساعات.",
  "Ringtone & Do not disturb": "نغمة الرنين و«عدم الإزعاج»",
  "How a call sounds on this device, and when calls should not ring at all.":
    "كيف يبدو صوت المكالمة على هذا الجهاز، ومتى لا ينبغي أن ترنّ المكالمات أصلاً.",
  Ringtone: "نغمة الرنين",
  "Preview {name}": "استمع إلى {name}",
  Preview: "استماع",
  Volume: "مستوى الصوت",
  "Kept in this browser. A meeting reminder plays the chime, quieter. The browser may keep the first ring silent until the page has been clicked once.":
    "محفوظة في هذا المتصفح. يُشغَّل تذكير الاجتماع بنغمة الجرس، أخفض صوتاً. وقد يُبقي المتصفح الرنين الأول صامتاً حتى يُنقر على الصفحة مرة.",
  "Calls ring as usual.": "المكالمات ترنّ كالمعتاد.",
  "Still rings through:": "يظل يرنّ رغم ذلك:",
  nobody: "لا أحد",
  "Choose a person who may ring through": "اختر شخصاً يمكنه الرنين رغم ذلك",
  "Add a person…": "أضف شخصاً…",
  "The people listed ring through whenever you are on Do not disturb. An urgent call also rings through when the administrator lets the caller's level do that (Who can call whom).":
    "الأشخاص المدرجون يرنّون كلما كنت في وضع «عدم الإزعاج». وترنّ المكالمة العاجلة أيضاً حين يسمح المسؤول لمستوى المتصل بذلك (من يتصل بمن).",
  Classic: "كلاسيكية",
  "Two notes, twice — the first tone": "نغمتان، مرتين — النغمة الأولى",
  Chime: "جرس",
  "A bell, gently": "جرس، بهدوء",
  Marimba: "ماريمبا",
  "A quick wooden run": "تتابع خشبي سريع",
  "Four short beeps": "أربع صفارات قصيرة",
  Digital: "رقمية",
  "An old desk phone's trill": "رنّة هاتف مكتب قديم",
  Soft: "ناعمة",
  "Low and slow, for a quiet office": "منخفضة وبطيئة، لمكتب هادئ",
  "Three notes, like an airport announcement": "ثلاث نغمات، كإعلان في المطار",
  "{name} muted you": "كتم {name} صوتك",
  "The host muted you": "كتم المضيف صوتك",
  "{name} removed you from the call": "أخرجك {name} من المكالمة",
  "The host removed you from this call": "أخرجك المضيف من هذه المكالمة",
  "You are in — the host let you join": "أنت في المكالمة — سمح لك المضيف بالانضمام",
  "The host did not let you in": "لم يسمح لك المضيف بالدخول",
  "You are now the host": "أنت الآن المضيف",
  "{name} is now the host": "{name} هو المضيف الآن",
  "{name} started sharing — yours stopped": "بدأ {name} المشاركة — وتوقفت مشاركتك",
  "Somebody else started sharing — yours stopped": "بدأ شخص آخر المشاركة — وتوقفت مشاركتك",
  "Nobody could be rung.": "تعذّر الاتصال بأي أحد.",
  "Screen sharing is not available in this browser.": "مشاركة الشاشة غير متاحة في هذا المتصفح.",
  "This platform cannot join calls yet.": "لا تستطيع هذه المنصة الانضمام إلى المكالمات بعد.",
  "Only invited people can join this call": "لا ينضم إلى هذه المكالمة إلا المدعوون",
  "The host has locked this call": "أقفل المضيف هذه المكالمة",
  "This call has ended.": "انتهت هذه المكالمة.",
  "+{n} more reminder|+{n} more reminders":
    "لا تذكيرات أخرى|+تذكير آخر|+تذكيران آخران|+{n} تذكيرات أخرى|+{n} تذكيراً آخر|+{n} تذكير آخر",
  /* a meeting going on now — not "Live" as a switched-on setting */
  "Live@call": "مباشر",
};
export default ar;
